import FlashLib from "flashlib";
import GlobalDispatcher from "Engine/events/GlobalDispatcher";
import EntryPoint from "Engine/EntryPoint";

export default class BasePaytableContainer extends FlashLib.MovieClip {
    constructor(data, displayItemData) {
        super(data, displayItemData);

        //this.interactive = true;
        this.container = null;

        this.init();
        this.addActions();
        this.addListeners();
        this.addScrollListeners();
        this.getContainer();
        this.hide();
    }

    init() {
        //this.getChildAt(0).alpha = 0.9;
        this.background = this.getChildAt(0);
        let w = this.background.width;
        let h = this.background.height;
        this.background.clear();
        this.background.beginFill(0x0, 0.9);
        this.background.drawRect(-w / 2, -h / 2, w, h);
        this.background.endFill();

        this.scrollableContainer = this.getChildAt(1);
        this.scrollableContainer.scrollable = true;
        this.scrollableContainer.interactive = true;
        this.scrollableContainer.alpha = 0;
        this.scrollableContainer.on('scroll', this.onScroll, this);
        //this.scrollableContainer.visible = false;

        this.maskContainer = this.getChildAt(4);

        this.closeButton = this.getChildByName('closeButton');
        if (this.closeButton) {
            this.closeButton.enabled = true;
        }

        this.initMaskParams();
    }

    initMaskParams() {
        this.baseY = this.maskContainer.y - this.maskContainer.height / 2; //110;
        this.maskHeight = this.maskContainer.height; //800; //840;
        this.bottomY = this.baseY + this.maskHeight;
    }

    addActions() {
        if (this.closeButton) {
            this.closeButton.actions = {
                click: {
                    callback: this.hide, context: this
                },
                touchend: {
                    callback: this.hide, context: this
                }
            };
        }
    }

    addListeners() {
        GlobalDispatcher.add('ui:paytableClick', this.onPaytableClick, this);
        GlobalDispatcher.add('ui:paytableShow', this.show, this);
        GlobalDispatcher.add('ui:paytableHide', this.hide, this);
        GlobalDispatcher.add('paytable:goToPage', this.onGoToPage, this);
        GlobalDispatcher.add('paytable:close', this.hide, this);

        /*EntryPoint.Game.app.view.addEventListener('wheel', (ev) => {
            mousePosition.set(ev.clientX, ev.clientY);
            const found = EntryPoint.Game.app.renderer.plugins.interaction.hitTest(
                mousePosition,
                EntryPoint.Game.app.stage
            );
            if (found) {
                found.emit('scroll', ev);
            }
        });*/
    }

    addScrollListeners() {
        EntryPoint.Game.app.view.addEventListener('wheel', this.onWheel.bind(this));
    }

    onWheel(event) {
        const data = event.touches ? event.touches[0] : event;
        const mousePosition = new PIXI.Point();
        mousePosition.set(data.clientX, data.clientY);
        const found = EntryPoint.Game.app.renderer.plugins.interaction.hitTest(
            mousePosition,
            //this.scrollableContainer
            EntryPoint.Game.app.stage
        );
        if (found && found.scrollable) {
            found.emit('scroll', event);
        }
    }

    onGoToPage(event) {
        this.goToPage(event.params);
    }

    onPaytableClick() {
        if (this.visible) {
            this.hide();
        } else {
            this.show();
        }
    }

    goToPage(data) {
        switch (data) {
            case 'increase':
                this.goToNextFrame(true);
                break;
            case 'decrease':
                this.goToPreviousFrame(true);
                break;
            default:
                this.goToFrame(data);
        }

        this.getContainer();
        GlobalDispatcher.dispatch('paytable:pageChanged', this.currentFrameIndex);
    }

    getContainer() {
        this.container = this.getChildByName('container');
        this.scrollBar = this.getChildByName('scrollBar');
        if (this.scrollBar) {
            this.scrollBar.setData({contentHeight: this.container.height, containerHeight: this.maskHeight});
            this.scrollBar.value = 0;
            this.scrollBar.on('update', (data) => {
                let totalValue = Math.abs(this.container.height - this.maskHeight);
                this.container.y = this.baseY - (totalValue * (data / 100));
            });
        }
    }

    onScroll(event) {
        if (this.container.height <= this.scrollableContainer.height) {
            return;
        }
        if (event.wheelDelta > 0) {
            if (this.container.y + event.wheelDelta <= this.baseY) {
                this.container.y += event.wheelDelta;
            } else {
                this.container.y = this.baseY;
            }
        } else {
            if (this.container.y + this.container.height + event.wheelDelta >= this.bottomY) {
                this.container.y += event.wheelDelta;
            } else {
                this.container.y = this.bottomY - this.container.height;
            }
        }

        if (this.scrollBar) {
            let totalValue = Math.abs(this.container.height - this.maskHeight);
            let value = Math.abs(this.container.y -this. baseY);
            let currentValue = value / totalValue;

            this.scrollBar.value = currentValue * 100;
        }
    }

    /*getContainer() {
        let baseY = 110;
        let maskHeight = 800; //840;
        let bottomY = baseY + maskHeight;

        this.container = this.getChildByName('container');

        this.scrollBar = this.getChildByName('scrollBar');
        if (this.scrollBar) {
            this.scrollBar.setData({contentHeight: this.container.height, containerHeight: maskHeight});
            this.scrollBar.value = 0;
            this.scrollBar.on('update', (data)=>{
                let totalValue = Math.abs(this.container.height - maskHeight);
                this.container.y = baseY - (totalValue * (data / 100));
            });
        }

        this.container.hitArea = new PIXI.Rectangle(0, 0, this.container.width, this.container.height);
        this.container.interactive = true;
        this.container.on('scroll', (event) => {
            if (event.wheelDelta > 0) {
                if (this.container.y + event.wheelDelta <= baseY) {
                    this.container.y += event.wheelDelta;
                } else {
                    this.container.y = baseY;
                }
            } else {
                if (this.container.y + this.container.height + event.wheelDelta >= bottomY) {
                    this.container.y += event.wheelDelta;
                } else {
                    this.container.y = bottomY - this.container.height;
                }
            }

            if (this.scrollBar) {
                let totalValue = Math.abs(this.container.height - maskHeight);
                let value = Math.abs(this.container.y - baseY);
                let currentValue = value / totalValue;

                this.scrollBar.value = currentValue * 100;
            }
        });
    }*/

    show() {
        //this.goToPage(1);
        this.visible = true;
    }

    hide() {
        GlobalDispatcher.dispatch('paytable:closed');
        this.visible = false;
    }

    destroy(options) {
        GlobalDispatcher.remove('ui:paytableClick', this.onPaytableClick, this);
        GlobalDispatcher.remove('paytable:goToPage', this.onGoToPage, this);
        GlobalDispatcher.remove('paytable:close', this.hide, this);
        super.destroy(options);
    }
}